export const isModernBrowser =
  typeof document !== 'undefined'
    ? Boolean(document.createElement('input').setSelectionRange)
    : true;

export const KEYS = {
  UP: 38,
  DOWN: 40,
  RIGHT: 39,
  LEFT: 37,
  ENTER: 13,
  ESC: 27,
  PLUS: 43,
  A: 65,
  Z: 90,
  SPACE: 32,
};
